// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

const pkg = require('../../package.json');

export const environment = {
  production: false,
  version: pkg.version,
  firebase: {
      apiKey: 'AIzaSyBOTZyN3cxwh02DMvW3CSKSRexxi3_Uog0',
      authDomain: 'combustion-pass.firebaseapp.com',
      databaseURL: 'https://combustion-pass.firebaseio.com',
      projectId: 'combustion-pass',
      storageBucket: 'combustion-pass.appspot.com',
      messagingSenderId: '544001451184'
  },
  timezone: 'America/New_york',
    status: {
        'default' : {
            'name': 'New',
            'color': 'warning',
            'color_name': 'orange'
        },
        0: {
            'name': 'Pending',
            'color': 'danger',
            'color_name': 'red'
        },
        1: {
            'name': 'Started',
            'color': 'success',
            'color_name': 'green'
        },
        2: {
            'name': 'Review',
            'color': 'info',
            'color_name': 'blue'
        },
        3: {
            'name': 'Production',
            'color': 'primary',
            'color_name': 'purple'
        },
    },
    project_parts: ['is_designed', 'is_developed', 'is_content', 'is_released'],
    production_flag: 'is_released',
    notification_setting: {
        timer: 100,
        from: 'bottom',
        align: 'center'
    },
    project_color: false,
    default_color: '#aa46bc',
    social: ['facebook', 'twitter', 'googleplus', 'instagram', 'pinterest', 'reddit', 'snapchat'],
    platforms: [
        {
          name: 'Angular 2+',
          icon: 'https://angular.io/assets/images/logos/angular/angular.png'
        },
        {
            name: 'Wordpress',
            icon: 'https://s.w.org/about/images/logos/wordpress-logo-notext-rgb.png'
        },
        {
            name: 'Magento',
            icon: 'https://seeklogo.com/images/M/magento-logo-7F3911AE9E-seeklogo.com.png'
        },
        {
            name: 'ReactJS',
            icon: 'https://www.shareicon.net/data/512x512/2016/07/08/117367_logo_512x512.png'
        },
        {
            name: 'React Native',
            icon: 'https://raw.githubusercontent.com/lucasbento/react-native-actions/master/common/media/logo.png'
        },
        {
            name: 'Custom',
            icon: 'https://png.icons8.com/metro/540/source-code.png'
        }
    ],
    dialogs: {
        width: '460px',
    },
    countries: require('../assets/countries.json'),
    zones: require('../assets/timezones.json'),
    filters: {
      projects: ['platform', 'status', 'deadline', 'added'],
      freelancers: ['profile', 'country', 'added', 'time']
    }
};



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/environments/environment.ts